var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#333333"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9996 7.71436C12.4237 7.71436 7.71387 12.4242 7.71387 18.0001C7.71387 23.576 12.4237 28.2858 17.9996 28.2858C23.5755 28.2858 28.2853 23.576 28.2853 18.0001C28.2853 12.4242 23.5755 7.71436 17.9996 7.71436ZM17.9996 12.8572C19.7759 12.8572 21.0853 14.1656 21.0853 15.9429C21.0853 17.7203 19.7759 19.0286 17.9996 19.0286C16.2243 19.0286 14.9139 17.7203 14.9139 15.9429C14.9139 14.1656 16.2243 12.8572 17.9996 12.8572ZM12.7477 22.9084C13.6703 21.5507 15.2091 20.6456 16.971 20.6456H19.0282C20.7911 20.6456 22.3288 21.5507 23.2515 22.9084C21.937 24.3155 20.0722 25.2001 17.9996 25.2001C15.927 25.2001 14.0622 24.3155 12.7477 22.9084Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPerson);
export default __webpack_public_path__ + "static/media/icon_person.53d58e37c35994f8d88bfd6c26d0f259.svg";
export { ForwardRef as ReactComponent };